
import   React,
       { useEffect,
         useState,
         useRef,
         useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography,
         Switch,
         Button,
         ButtonGroup,
         Grid,
         List,
         ListItem,
         ListItemText,
         Container,
         Drawer,
         Divider } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { set_webcam_resolution, } from '../util/util';
import { CONSTS, INFO, CONSLOG } from '../util/object'
import { AuthClass } from '../class/AuthClass';
import { appContext } from "./index";
import { NoEncryption } from '@material-ui/icons';
var auth = new AuthClass();



const secret_useStyles = makeStyles(theme => ({
    secret_container: {
        position: "absolute",       // rides on top
        top: '8%',
        padding: '0',
        margin: '0',
        width: "85%",
        height: "84%",
        color: 'white',
        zIndex: '380',
    },
    title_container: {
        display: "flex",
        height: '100%',
        width: '100%',
        maxWidth: "100%",
        padding: '0',
        margin: '0',
        alignSelf: 'start',
    },
    conslog_container: {
        display: "flex",
        height: '100%',
        width: '100%',
        maxWidth: "100%",
        padding: '0',
        margin: '0',
        alignSelf: 'start',
        zIndex: '400',
    },
    btn_group_container: {
        display: "flex",
        padding: '0',
        margin: '0',
        color: 'white',
        justifyContent: 'flex-start',
        flexDirection: "column",
        overflowY: 'scroll',
    },
    buttons_row: {
        display: "flex",
        padding: '0',
        margin: '3px 0',
        fontSize: "0.7 rem",
    },
    btn_body: {
        padding: 0,
        fontSize: 0.7 +'rem',
        background: '#696096',
    },
    btn_label: {
        display: "flex",
        padding: '0',
        margin: '0 10px 0 0',
        flexDirection: "row",
        justifyContent: 'flex-start',
        alignSelf: 'start',
        fontSize: '0.8rem',
        color: 'white',
        background: "none",
    },
}))

// hidden admin menu to enable special debug params
//     - Webcam Rez: Change recording resolution to create demo videos
//
export const SecretMenu = (props) => {
    const classes = secret_useStyles();
    const { State } = useContext(appContext);
    const [ Style, setStyle ] = useState({});

    const btn_style =  {
        padding: 0,
        fontSize: 0.6 +'rem',
        background: '#696096',
    }

    useEffect(() => {
        //setStyle({});

    }, [1]);

    useEffect(() => {
        var style = {}
        if(props.Color !== undefined) {
            style.backgroundColor = props.Color;
        } else {
            style.backgroundColor = 'rgba(43, 65, 120, 0.95)';
        }
        if(props.ZIndex !== undefined) {
            //style["zIndex"] = props.ZIndex;
            style.zIndex = "420";
        }
        style.color="red";
        console.log("dismiss.419:  style=",style, "  zindx=",props.ZIndex, "  color=",props.Color);
        setStyle(style);
    }, [props.Color, props.ZIndex]);

    useEffect(() => {
    }, [Style]);


    const handleRez = pub => (event) => {
        console.log("secret.1194:  Process Recording Resolution ", pub);
        switch(pub) {
            case "high":
                set_webcam_resolution("high");
                break;
            case "med":
                set_webcam_resolution("med");
                break;
            case "low":
                set_webcam_resolution("low");
                break;
        }
    }

    const handleMock = type => (event) => {
        console.log("secret.1194:  Process Simulation Type ", type);
        switch(type) {
            case "measure":
                INFO.mock_type = "measure";
                break;
            case "target":
                INFO.mock_type = "target";
                break;
            case "passing":
                INFO.mock_type = "passing";
                break;
            case "position":
                INFO.mock_type = "position";
                break;
        }
    }

    const handleDebugSplash = pub => (event) => {
        auth.setCookie(CONSTS.COOKIE_DEBUG_SPLASH, pub);
    }

    const handleConsoleLog = pub => (event) => {
        //console.log("secret.1106:   Show Console Log props=", props);
        props.ConsLog();
    }


    // DEBUG: disable horizontal enforcement for AT camera
    //
    const handleForceHorizontal = value => (event) => {
        console.log("secret.162:   ! ! ! ! ! ! !   ENFORCE HORIZONTAL MODE SET TO =", value);
        INFO.enforce_horizontal_mode = value;
    }


                        /*
                        <ButtonGroup size="small" className={classes.buttons_row}>
                            <div className={classes.btn_label} > SIMULATOR </div>
                            <Button style={btn_style} onClick={handleMock("measure")}> MEASURE </Button>
                            <Button style={btn_style} onClick={handleMock("target")}> TARGET </Button>
                            <Button style={btn_style} onClick={handleMock("passing")}> PASSING </Button>
                            <Button style={btn_style} onClick={handleMock("position")}> POSITION </Button>
                        </ButtonGroup>
                        */

    return (
            <Container id="dismiss" className={classes.secret_container} style={{ zIndex: "880" }}> 
                <Container id="btn_list" className={classes.title_container} >
                    <Container className={classes.btn_group_container} >

                        <ButtonGroup size="small" className={classes.buttons_row}>
                            <div className={classes.btn_label} > WEBCAM RES </div>
                            <Button style={btn_style} onClick={handleRez("high")}> HIGH </Button>
                            <Button style={btn_style} onClick={handleRez("med")}> MED </Button>
                            <Button style={btn_style} onClick={handleRez("low")}> LOW </Button>
                        </ButtonGroup>

                        <ButtonGroup size="small" className={classes.buttons_row}>
                            <div className={classes.btn_label}> DEBUG SPLASH </div>
                            <Button style={btn_style} onClick={handleDebugSplash(true)}> YES </Button>
                            <Button style={btn_style} onClick={handleDebugSplash(false)}> NO </Button>
                        </ButtonGroup>

                        <ButtonGroup size="small" className={classes.buttons_row}>
                            <div className={classes.btn_label}> FORCE HORIZONTAL </div>
                            <Button style={btn_style} onClick={handleForceHorizontal(true)}> YES </Button>
                            <Button style={btn_style} onClick={handleForceHorizontal(false)}> NO </Button>
                        </ButtonGroup>

                        <ButtonGroup size="small" className={classes.buttons_row}>
                            <div className={classes.btn_label}> SHOW LOG </div>
                            <Button style={btn_style} onClick={handleConsoleLog(true)}> YES </Button>
                        </ButtonGroup>

                    </Container>
                </Container>
            </Container>
    )
}
